import { render, staticRenderFns } from "./KshRoleMenuList.vue?vue&type=template&id=68c23f1c&scoped=true&"
import script from "./KshRoleMenuList.vue?vue&type=script&lang=js&"
export * from "./KshRoleMenuList.vue?vue&type=script&lang=js&"
import style0 from "./KshRoleMenuList.vue?vue&type=style&index=0&id=68c23f1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c23f1c",
  null
  
)

export default component.exports